var React = require('react');

function Remove2 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_2_1479)","key":0},React.createElement("path",{"d":"M23.9994 12.776H12.7754H11.2234H-0.000610352V11.224H11.2234H12.7754H23.9994V12.776Z","fill":"white"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2_1479"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

Remove2.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Remove2;

Remove2.default = Remove2;
